import { useSearchParams } from "react-router-dom";
import { useFetchNotesList } from "../../../hooks/queries/note";
import { useAppSelector } from "../../../hooks/useRedux";
import { convertUrlSearchParamsToObject } from "../../../utils/helpers";
import { INotesFilterTypes } from "../types/notes.types";
import { getInsuranceProviderIdsFilter } from "../../../shared-ui/InsuranceProviderFilter/InsuranceProviderFilter";

interface INotesFilterTypesForLs extends INotesFilterTypes {
    sort_attr: string;
}

export function useNotesListFromLocalStorage() {
    const [searchParams] = useSearchParams();
    const { practice } = useAppSelector((state) => state.userPractice);

    const notesFiltersFromLocalStorage =
        localStorage.getItem("notelist_filters");

    const notesPageParamsObj = notesFiltersFromLocalStorage
        ? convertUrlSearchParamsToObject<INotesFilterTypesForLs>(
              notesFiltersFromLocalStorage
          )
        : null;

    const notesTabNameQuery = notesPageParamsObj?.tab_name as string;
    const activeBtnInLS = localStorage.getItem("activeBtn");

    const viewAll =
        notesTabNameQuery === "all_notes" || activeBtnInLS === "all_notes";

    const notesList = useFetchNotesList(
        {
            status: notesPageParamsObj?.status || [],
            type: notesPageParamsObj?.type || [],
            cpt_code: notesPageParamsObj?.cpt_code || "",
            insurance_provider_ids: notesFiltersFromLocalStorage
                ? getInsuranceProviderIdsFilter(
                      new URLSearchParams(notesFiltersFromLocalStorage)
                  )
                : [],
            from_date: notesPageParamsObj?.from_date || null,
            to_date: notesPageParamsObj?.to_date || null,
            from_created_at_date:
                notesPageParamsObj?.from_created_at_date || null,
            to_created_at_date: notesPageParamsObj?.to_created_at_date || null,
            search_string: notesPageParamsObj?.search_string || "",
            author_id: notesPageParamsObj?.author_id || "",
            show_archived: notesPageParamsObj?.show_archived || "false",
            page: Number(notesPageParamsObj?.page) || 1,
            limit: Number(notesPageParamsObj?.limit) || 100,
            sort_attribute: notesPageParamsObj?.sort_attr || undefined,
            sort_order: notesPageParamsObj?.sort_order || undefined,
            tab_name: viewAll ? "all_notes" : "",
        },
        viewAll ? "" : (practice?.provider_id as string),
        Boolean(
            !(
                notesPageParamsObj?.status &&
                notesPageParamsObj.status.length === 1 &&
                /,+/.test(notesPageParamsObj.status[0])
            )
        )
    );

    const noteListType = searchParams.get("noteListType") || "";

    return {
        notesList,
        notesPageParamsObj,
        viewAll,
        noteListType,
    };
}
